export interface FrodoCustomTestValidationInput {
  name: string;
  maxDistanceToStop: number;
  maxWaitTimeMinutes: number;
}

export interface FrodoCustomTestValidationErrors {
  name?: string;
  maxDistance?: string;
  maxWait?: string;
}

export function validateFrodoCustomTestInput(
  input: FrodoCustomTestValidationInput
): FrodoCustomTestValidationErrors {
  const errors: FrodoCustomTestValidationErrors = {};

  if (!input.name.trim()) {
    errors.name = 'Test name is required';
  }
  if (input.maxDistanceToStop <= 0) {
    errors.maxDistance = 'Maximum distance must be greater than 0';
  }
  if (input.maxWaitTimeMinutes <= 0) {
    errors.maxWait = 'Maximum wait time must be greater than 0';
  }

  return errors;
}
